import { Component,
    Input,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TreeComponent, TreeService, TreeNode } from '../../../../../common/tree';
import { DCService } from './dc.service';
import { Subscription } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DCTreeConstants } from './dc-tree-constants';
import  inventoryRouteMapper  from './dc-route-mapper';
import { DataPasserService } from '../data-passer/data-passer.service';
import { DataPasser } from '../data-passer/data-passer';
import { RefreshSharedService } from '../../../../refresh-shared-service';
const _ = require('lodash');


@Component({
    selector: 'dc-tree-holder',
    providers: [ DCService, TreeService],
    styles: [
        require('./dc-tree-holder.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./dc-tree-holder.html')
})

export class DCTreeHolder implements OnChanges {
    @Input() state: any;
    @Input() entityType: string;
    @Input() set url(url: String) {};
    @Input() set linksMap(linksMap: any) {};
    @Input() set actionsMap(actionsMap: any) {};

    private childrenUrl: String = "/hybridity/api/vc/query?";
    private selected: DataPasser = { entity_id: '', type: '', name: '', vcenter_instanceId: '', vcHost: '', owner: {}};

    private selectedSearchType: any = '1';
    private nodes = [];
    private originalNodes = [];
    private subscription: Subscription;
    private refreshSubscription: Subscription;
    private menuActionMapping = {};
    private menuLinksMapping = {};
    private vcUuidToNameMap = [];
    private refresh: Subscription;
    @Input() nodeToBeSelectedOnLoad: string;
    private rsService: RefreshSharedService;
    private showTree: boolean = false;
    private isLoading: boolean = false;

    options = {
        idField: 'entity_id',
        displayField: 'name',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: false,
        contextMenuActionMapping: this.menuActionMapping,
        menuLinksMapping: this.menuLinksMapping,
        typeField: 'entityType',
        leafTypes: ['vm', 'host'],
        hideSystemFolders: true
    };

    @ViewChild(TreeComponent)
    private tree: TreeComponent;

    constructor(public inventoryTree: DCService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private treeService: TreeService,
                private router: Router,
                private route: ActivatedRoute,
                public passer: DataPasserService,
                private rss: RefreshSharedService) {

                this.rsService = rss;
    }

    ngOnInit() {
    }

    getElementReference() {
        return this.elementRef;
    }
//group-h, group-s, group-n
    removeHiddenFolders(nodes = []) {
        let resultNodes = [];
        let entityId: string;
        nodes.forEach(function(node) {
            entityId = node['entity_id'];
            if (entityId.indexOf('group-h') === -1 && entityId.indexOf('group-s') === -1 && entityId.indexOf('group-n') === -1) {
                resultNodes.push (node);
            }
        })
        return resultNodes;
    }

    getClusterComputeResource(nodes = []) {
        let resultNodes = [];
        let entityId: string;
        nodes.forEach(function(node) {
            if (node.parent && node.parent.type !== 'ComputeResource') {
                resultNodes.push (node);
            }
        })
        return resultNodes;
    }

    removeMobilityAgent(nodes = []) {
        let resultNodes = [];
        let entityId: string;
        nodes.forEach(function(node) {
            if (!node.name.startsWith('ma-ds-')) {
                resultNodes.push (node);
            }
        })
        return resultNodes;
    }

    ngOnChanges(changes) {
        this.isLoading = true;
        if (changes && changes.url && changes.url.currentValue) {
            this.subscription =
            this.inventoryTree.getTreeNodes(changes.url.currentValue).subscribe((nodes: any) => {
                    this.showTree = (nodes && nodes.length > 0) ? true : false;
                    let resultNodes = _.cloneDeep(nodes);

                    if (this.entityType === 'folder') {
                        resultNodes = this.removeHiddenFolders(nodes);
                    }
                    if (this.entityType === 'resourcePool') {
                        resultNodes = this.getClusterComputeResource(nodes);
                    }
                    if (this.entityType === 'datastore') {
                        resultNodes = this.removeMobilityAgent(nodes);
                    }
                    this.nodes = resultNodes;
                    this.originalNodes = resultNodes;
                    this.setVcDetails(resultNodes, this);
                },
                error => {
                    console.log('Error on loading tree');
                    this.showTree = false;
                    this.isLoading = false;
                },
                () => {
                    this.isLoading = false;
                    setTimeout(() => {
                        if (this.nodeToBeSelectedOnLoad) {
                            let nodeToBeSelected = this.tree.treeService.getNodeById(this.nodeToBeSelectedOnLoad);
                            if (nodeToBeSelected) {
                                nodeToBeSelected.focus();
                            }
                        }
                    });
                }
            );
        }
        if (changes && changes.actionsMap && changes.actionsMap.currentValue) {
            this.menuActionMapping = changes.actionsMap.currentValue;
        }
        if (changes && changes.linksMap && changes.linksMap.currentValue) {
            this.menuLinksMapping = changes.linksMap.currentValue;
        }
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
        if( this.refresh ) {
            this.refresh.unsubscribe();
        }
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }

    }

    setVcDetails(nodes, this2) {
        for (let node of nodes) {
            if (node && node.entity_id && node.name) {
                this2.vcUuidToNameMap[node.entity_id] = node.name;
            }
        }
    }

    getChildren(node) {
        let vcId: String = node.data.vcenter_instanceId;
        let parentId: String = ( node.data.entityType === 'vcenter') ? 'group-d1' : node.data.entity_id;
        let entityType: String = node.data.entityType;
        if (entityType === 'datastore') {
            return;
        }
        return this.inventoryTree.getChildNodes(this.getChildrenUrl(parentId, vcId, entityType));
    }

    getChildrenUrl(parentId, vcId, entityType) {
        let url = this.childrenUrl + DCTreeConstants.getChildrenQueryParameters(entityType)
        + '&filter=parentId==' + parentId + ';vcenterId==' + vcId;
        return url;
    }

    getIconClass(node) {
    }

    onNodeSelection = ($event) => {
        let type = $event.node && $event.node && $event.node.data && $event.node.data.entityType ? $event.node.data.entityType : '',
            routePath = inventoryRouteMapper[type],
            id = $event.node && $event.node && $event.node.data && $event.node.data.entity_id ? $event.node.data.entity_id : '';
        let name = $event.node && $event.node.data && $event.node.data.name ? $event.node.data.name : '';
        let vcenter_instanceId = $event.node && $event.node.data && $event.node.data.vcenter_instanceId ? $event.node.data.vcenter_instanceId : '';
        let vcHost = this.vcUuidToNameMap && vcenter_instanceId ? this.vcUuidToNameMap[vcenter_instanceId] : '';
        let owner = $event.node && $event.node.data && $event.node.data.owner ? $event.node.data.owner : {}; 
        this.selected = { entity_id: id , type: routePath, name: name, vcenter_instanceId: vcenter_instanceId, vcHost: vcHost, owner: owner};
        this.passer.setData(this.selected);
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
        console.log('Tree Initialised');
    };

    onFocus = ($event) => {
    };

    treeFilter(tree, value) {
        tree.treeService.filterNodes(value, true);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/deployment-container/dc-tree/dc-tree-holder.component.ts